import { theme } from '@televet/kibble-ui';

const ottoText = `%c
                                                      %c
                                           .-:        
                :-.       :-.        .*#+ :*##:  ..   
                ##*      :##+        .*#* :+*+.=*##-  
    .:-==-:.   .###----: :##*----:    :-===-:  =#*+   
  :*##*++*##+. .###****+ :##*****+  :*##*++*#*=  :--: 
 .*#*:    :##* .###      :##+      -##+     =##= *##+ 
 -##=      *##..###      :##+      =##-      ##* .:.  
 .*#*:    -##*  ###   :-..##*   :- -##+.    =##=      
  .+##*++*#*=   -*#*+*##- =##*+*#*: :*##*++*#*=       
    .:-==-:       :-=--.   .-==-:     .--==-:         
%c                                                      `;
const borderRadiusTop = 'border-radius: 40px 40px 0 0;';
const borderRadiusBottom = 'border-radius: 0 0 40px 40px;';

const fontWeight = `font-weight: ${theme.fontWeights.bold};`;
const backgroundColor = `background-color: #4F830F0A;`;
const textColor = `color: #4F830F;`;
export const logOtto = (): void => {
  console.log(
    ottoText,
    `${borderRadiusTop} ${fontWeight} ${textColor} ${backgroundColor}`,
    `${fontWeight} ${textColor} ${backgroundColor}`,
    `${borderRadiusBottom} ${fontWeight} ${textColor} ${backgroundColor}`,
  );
};
